import React, { useState } from "react";
import "./Navbar1.css";
import logo from "../../../assets/Logo1.png";
import { FiChevronDown, FiMenu, FiX } from "react-icons/fi";

const Navbar1 = ({ onNavigate }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <nav className="navbar1">
      <div className="navbar1-logo">
        <img src={logo} alt="AI Shipshape Logo" />
      </div>

      

      <ul className={`navbar1-links ${menuOpen ? "show" : ""}`}>
        <li onClick={() => onNavigate("main")}>Home</li>
        <li onClick={() => onNavigate("about")}>About Us</li>
        <li onClick={() => onNavigate("contact")}>Contact Us</li>

        <li className="navbar1-dropdown">
          Services <FiChevronDown size={14} />
          <ul className="navbar1-dropdown-menu">
            <li>
              <button onClick={() => onNavigate("services1")} className="dropdown-button">
                Weather Routing and Voyage Optimization
              </button>
            </li>
            <li>
              <button onClick={() => onNavigate("services2")} className="dropdown-button">
                Vessel Optimization
              </button>
            </li>
            <li>
              <button onClick={() => onNavigate("services3")} className="dropdown-button">
                Carbon Emission Reporting
              </button>
            </li>
            <li>
              <button onClick={() => onNavigate("services4")} className="dropdown-button">
                Shipshape Chat Suite™
              </button>
            </li>
          </ul>
        </li>

        {/* <li className="navbar1-dropdown">
          Upcoming <FiChevronDown size={14} />
          <ul className="navbar1-dropdown-menu">
            <li>
              <button onClick={() => onNavigate("upcoming1")} className="dropdown-button">
                Shipshape ThrustPower™
              </button>
            </li>
            <li>
              <button onClick={() => onNavigate("upcoming2")} className="dropdown-button">
                Shipshape Engine Performance™
              </button>
            </li>
            <li>
              <button onClick={() => onNavigate("upcoming3")} className="dropdown-button">
                Shipshape Vision Mass Flow Reader™
              </button>
            </li>
          </ul>
        </li> */}
      </ul>

      <button className="navbar1-join" onClick={() => onNavigate("contact")}>
        JOIN
      </button>

       <button className="navbar1-toggle" onClick={toggleMenu}>
        {menuOpen ? <FiX /> : <FiMenu />}
      </button>
      
    </nav>
  );
};

export default Navbar1;
